import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { BrowserView, MobileView } from 'react-device-detect'
import { Fade } from 'react-awesome-reveal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretLeft, faHeart } from '@fortawesome/free-solid-svg-icons'
import Button from '../Utils/Button'
import '../../styles/Nav/Nav.css'
import '../../styles/Nav/NavBurger.css'
import logoBanner from '../../assets/images/nav/logoBanner.png'

function Nav() {

    const navigate = useNavigate()
    const location = useLocation()
    const [menuDisplayMobile, setMenuDisplayMobile] = useState(false)
    const [navBurgerColor, setNavBurgerColor] = useState(null)

    const navLinks = [
        {
            name: 'Accueil',
            link: '/'
        }, {
            name: 'À propos',
            link: '/%C3%A0-propos',
            sublinks: [
                {
                    name: 'Notre équipe',
                    link: '/%C3%A0-propos/notre-équipe'
                }, {
                    name: 'Qui sommes-nous ?',
                    link: '/%C3%A0-propos/qui-sommes-nous'
                }, {
                    name: 'Notre fonctionnement',
                    link: '/%C3%A0-propos/notre-fonctionnement'
                }
            ]
        }, {
            name: 'Objectifs',
            link: '/objectifs',
            sublinks: [
                {
                    name: 'La santé',
                    link: '/objectifs/santé'
                }, {
                    name: 'L\'éducation',
                    link: '/objectifs/éducation'
                }, {
                    name: 'L\'habitat',
                    link: '/objectifs/habitat-construction'
                }, {
                    name: 'L\'aide humanitaire',
                    link: '/objectifs/aide-humanitaire'
                }, {
                    name: 'Le développement durable',
                    link: '/objectifs/développement-durable'
                }
            ]
        }, {
            name: 'Actualités',
            link: '/actualit%C3%A9s'
        }, {
            name: 'Contactez-nous',
            link: '/contactez-nous'
        }
    ]

    useEffect(() => {

        getNavBurgerColors()

    }, [])

    function getNavBurgerColors() {

        const navBurgerColor = getComputedStyle(document.body).getPropertyValue('--navBurgerActive')
        setNavBurgerColor(navBurgerColor)

    }

    function displaySublink(type, idElement) {

        const link = document.getElementById(idElement)
        const sublink = link.querySelector('.navCenterSublinkContainer')
        const sublinkIcon = link.querySelector('.navCenterSublinkIcon')
        if (type === 'display') {
            sublink.style.height = (sublink.scrollHeight) + 'px'
            sublinkIcon.style.transform = 'rotate(-90deg)'
        } else if (type === 'hide') {
            sublink.style.height = '0'
            sublinkIcon.style.transform = 'rotate(0deg)'
        }

    }

    function displaySublink2(idElement, idSubElement) {

        const sublinkContainer = document.getElementById(idElement).querySelector('.navCenterSublinkContainer')
        const sublink = document.getElementById(idSubElement)
        const sublink2 = sublink.querySelector('.navCenterSublink2Container')
        const sublinkIcon = sublink.querySelector('.navCenterSublinkIcon')
        if (sublink2.style.height === '0px' || !sublink2.style.height) {
            sublinkContainer.style.height = (sublinkContainer.scrollHeight + sublink2.scrollHeight) + 'px'
            sublink2.style.height = (sublink2.scrollHeight) + 'px'
            sublinkIcon.style.transform = 'rotate(-90deg)'
        } else {
            sublinkContainer.style.height = (sublinkContainer.scrollHeight - sublink2.scrollHeight) + 'px'
            sublink2.style.height = '0'
            sublinkIcon.style.transform = 'rotate(0deg)'
        }

    }

    function displayLinkBurger() {

        var navMobile = document.getElementById("navMobileLink")
        var nav = document.getElementById("navBurger")
        if (!menuDisplayMobile) {
            setMenuDisplayMobile(true)
            navMobile.style.height = (navMobile.scrollHeight) + 100 + 'px'
            navMobile.style.padding = "30px 0 30px 0"
            if (nav) {
                nav.style.background = getComputedStyle(document.body).getPropertyValue('--navBurger')
            }
        } else {
            window.scrollTo({ top: 0, behavior: 'instant' })
            setMenuDisplayMobile(false)
            navMobile.style.height = "0"
            navMobile.style.padding = "0"
            if (nav) {
                nav.style.background = getComputedStyle(document.body).getPropertyValue('--nav')
            }
        }

    }

    function hideLinkBurger() {

        window.scrollTo({ top: 0, behavior: 'instant' })
        const sublink2 = document.getElementsByClassName('navCenterSublink2ContainerMobile')
        for (let i = 0; i < sublink2.length; i++) {
            sublink2[i].style.height = '0'
        }
        const sublink = document.getElementsByClassName('navCenterSublinkContainerMobile')
        for (let i = 0; i < sublink.length; i++) {
            sublink[i].style.height = '0'
        }
        const sublinkIcon = document.getElementsByClassName('navCenterSublinkIconMobile')
        for (let i = 0; i < sublinkIcon.length; i++) {
            sublinkIcon[i].style.transform = 'rotate(0deg)'
        }
        const linkIcon = document.getElementsByClassName('navCenterLinkIconMobile')
        for (let i = 0; i < linkIcon.length; i++) {
            linkIcon[i].style.transform = 'rotate(0deg)'
        }
        const navMobile = document.getElementById("navMobileLink")
        const nav = document.getElementById("nav")
        setMenuDisplayMobile(false)
        if (navMobile) {
            navMobile.style.height = "0"
            navMobile.style.padding = "0"
        }
        if (nav) {
            nav.style.background = getComputedStyle(document.body).getPropertyValue('--nav')
        }

    }

    return (

        <nav>
            <BrowserView>
                <Fade direction={'down'} duration={500}>
                    <div id='nav'>
                        <div id='navLeft' sm={2}>
                            <Fade direction={'left'} duration={500}>
                                <img src={logoBanner} id='navLogo' alt='logo' onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate('/') }} />
                            </Fade>
                        </div>
                        <div id='navCenter' sm={8}>
                            {navLinks.map((item, index) => (
                                <div
                                    key={index}
                                    id={item.link}
                                    className={(location.pathname === '/' && item.link === '/') || (item.link !== '/' && location.pathname.startsWith("/" + item.link.split('/')[1])) ? 'navCenterLinkActive' : 'navCenterLink'}
                                    onMouseEnter={() => item.sublinks ? displaySublink('display', item.link) : null}
                                    onMouseLeave={() => item.sublinks ? displaySublink('hide', item.link) : null}>
                                    <Link to={!item.sublinks ? item.link : item.link} onClick={() => !item.sublinks ? window.scrollTo({ top: 0, behavior: 'instant' }) : null}>{item.name}</Link>
                                    {item.sublinks ?
                                        <>
                                            <FontAwesomeIcon icon={faCaretLeft} className='navCenterSublinkIcon' />
                                            <div className='navCenterSublinkContainer'>
                                                {item.sublinks.map((itemSublink, indexSublink) => (
                                                    <div
                                                        key={indexSublink}
                                                        id={itemSublink.link}
                                                        className='navCenterSublink'
                                                        onClick={(e) => {
                                                            if (itemSublink.sublinks2) {
                                                                e.preventDefault()
                                                                e.stopPropagation()
                                                                displaySublink2(item.link, itemSublink.link)
                                                            }
                                                        }}>
                                                        <Link to={!itemSublink.sublinks2 ? itemSublink.link : null} onClick={() => !itemSublink.sublinks2 ? window.scrollTo({ top: 0, behavior: 'instant' }) : null}>{itemSublink.name}</Link>
                                                        {itemSublink.sublinks2 ?
                                                            <>
                                                                <FontAwesomeIcon icon={faCaretLeft} className='navCenterSublinkIcon' />
                                                                <div className='navCenterSublink2Container'>
                                                                    {itemSublink.sublinks2.map((itemSublink2, indexSublink2) => (
                                                                        <div key={indexSublink2} className='navCenterSublink2'>
                                                                            <Link to={itemSublink2.link} onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}>{itemSublink2.name}</Link>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </>
                                                            : null
                                                        }
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                        : null
                                    }
                                </div>
                            ))}
                        </div>
                        <div id='navRight' sm={2}>
                            <Fade direction={'right'} duration={500}>
                                <Button theme={'dark'} icon={<FontAwesomeIcon icon={faHeart} className='buttonIcon' />} text={"Faire un don"} rounded={true} onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate('/donation') }} />
                            </Fade>
                        </div>
                    </div>
                </Fade>
            </BrowserView>
            {/* <div id='nav'> */}
            <MobileView>
                <div id='navMobile'>
                    <div id="navMobileBurger">
                        {/* <Fade direction={'left'} duration={500}> */}
                        <img src={logoBanner} id='navLogoMobile' alt='logo' onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate('/') }} />
                        {/* </Fade> */}
                        <div className={menuDisplayMobile ? "navMobileBurglar is-open" : "navMobileBurglar is-closed"} onClick={() => displayLinkBurger()}>
                            <div className="navMobileBurgerIcon">
                                <div className="navMobileBurgerIconContainer">
                                    <span className="navMobileBurgerBunTop"></span>
                                    <span className="navMobileBurgerFilling"></span>
                                    <span className="navMobileBurgerBunBot"></span>
                                </div>
                            </div>
                            <div className="burger-ring">
                                <svg className="svg-ring">
                                    <path className="path" fill="none" stroke={navBurgerColor} strokeMiterlimit="10" strokeWidth="4" d="M 34 2 C 16.3 2 2 16.3 2 34 s 14.3 32 32 32 s 32 -14.3 32 -32 S 51.7 2 34 2" />
                                </svg>
                            </div>
                            <svg width="0" height="0">
                                <mask id="mask">
                                    <path xmlns="http://www.w3.org/2000/svg" fill="none" stroke={navBurgerColor} strokeMiterlimit="10" strokeWidth="4" d="M 34 2 c 11.6 0 21.8 6.2 27.4 15.5 c 2.9 4.8 5 16.5 -9.4 16.5 h -4" />
                                </mask>
                            </svg>
                            <div className="path-burger">
                                <div className="animate-path">
                                    <div className="path-rotation"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id='navMobileLink'>
                    {navLinks.map((item, index) => {
                        return (
                            <div key={index}>
                                <div className='navMobileLinkText'>
                                    <Link
                                        to={item.link}
                                        onClick={() => hideLinkBurger()}>
                                        {item.name}
                                    </Link>
                                    <div id={item.link}>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    <div className='navMobileLinkButton'>
                        <Button theme={'dark'} icon={<FontAwesomeIcon icon={faHeart} className='buttonIcon' />} text={"Faire un don"} rounded={true} onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); hideLinkBurger(); navigate('/donation') }} />
                    </div>
                </div>
            </MobileView>
            {/* </div> */}
        </nav>

    )

}

export default Nav